import companyInfoJSON from './company-infos.json'
import INFO_GRAPHIC from './info.jpg'

export const STATIC_ROOT = {
    companyInfoJSON,
    INFO_GRAPHIC,
}